module.exports = __webpack_public_path__ + "static/media/cme-group.260965c1.jpeg";